import React from "react";

import { shortNumberFormat } from "@/utils/numbers";

interface CounterProps {
  /** Number this counter should display. */
  count: number;
  /** Optional max number (ie: N+) */
  countMax?: number;
}

/** A simple counter for alerts, etc. */
const Counter: React.FC<CounterProps> = ({ count, countMax }) => {
  return (
    <span className="flex h-5 max-w-[26px] min-w-[20px] items-center justify-center rounded-full bg-secondary-500 text-xs font-medium text-white ring-2 ring-white dark:ring-gray-900">
      {shortNumberFormat(count, countMax)}
    </span>
  );
};

export default Counter;
